/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import { useNavigate } from "react-router-dom";
import { toKebabCase } from "../../../utils/helperFunctions";
import DbSoftwareBuilds from "./DbSoftwareBuilds";
import OsBuilds from "./OsBuilds";

const SoftwareImageBuilds = () => {
  const [selectedTab, setSelectedTab] = useState("db-software");

  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/apps/tessell/software-images/${selectedTab}/builds`);
  }, [selectedTab]);

  const SOFTWARE_IMAGE_TYPES = ["DB Software", "OS"];

  return (
    <Box sx={tabbedDataGridPage.mainBox}>
      <Box sx={tabbedDataGridPage.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              textColor="secondary"
              indicatorColor="secondary"
              sx={tabbedDataGridPage.tabList}
            >
              {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
                <Tab
                  key={i}
                  label={swiType}
                  value={toKebabCase(swiType?.toLowerCase())}
                  icon={<></>}
                  iconPosition="end"
                />
              ))}
            </TabList>
          </Box>
          {SOFTWARE_IMAGE_TYPES?.map((swiType, i) => (
            <TabPanel key={i} value={toKebabCase(swiType?.toLowerCase())}>
              {swiType === "DB Software" ? <DbSoftwareBuilds /> : <OsBuilds />}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default SoftwareImageBuilds;
